export const ChevronLeft = ({ className }) => {

    return (
        <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M12.5 5.5 8 10l4.5 4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
            </path>
        </svg>
    )
    }

